let reject = /^[-]?(?!_)(?!.*?_$)+[a-zA-Z0-9_\u4e00-\u9fa5/:@.?&]+$/;
let regName = /^[-]?(?!_)(?!.*?_$)+[a-zA-Z0-9_\u4e00-\u9fa5/'":()\],]+$/;
// 特殊字符的判断（+）
let specialStr = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
// 判断密码（只能包含字母、数字以及标点符号（除空格），字母、数字和标点符号三者中至少包含 2 种。）
//?![\d]+$排除掉只是数字的组合   \\W即表示特殊字符
let pwd = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?![\W]+$)[0-9A-Za-z\W]{1,}$/;
// let pwd = /^(?![\d]+$)(?![a-zA-Z]+$)(?![`~!(){};'":?.,·~！（）{}’；“：？。，\[\]【】]+$)[\da-zA-Z`~!(){};'":?.,·~！（）{}’；“：？。，\[\]【】]{0,}$/;
// 邮箱
let email = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
// 身份证
let idCard = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
// 服务名称的验证(仅包含汉字，英文字母，数字，特殊字符)
let serveName = /^[a-zA-Z0-9\u4e00-\u9fa5\\W]{1,}$/;
// url的验证
var addressUrl = /^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-.,@?^=%&:\/~+#]*[\w\-@?^=%&\/~+#])?$/;
var userName = /^[\u4e00-\u9fa5]{1,}$/;
//账号校验
const account_valid = (rule, value, callback) => {
  let reg = /^[0-9A-Za-z]{5,25}$/;
  if (!value || value == '') {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (reg.test(value)) {
      callback();
    } else {
      callback(new Error(`${rule.label}只能包含数字，大小写字母，长度5-25`));
    }
  }
};
const validate_len1 = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (userName.test(value)) {
      if (value.length > rule.max_len) {
        callback(new Error(`${rule.label}的长度不能大于${rule.max_len}`));
      } else {
        callback();
      }
    } else {
      callback(new Error(`只允许输入中文字符`))
    }
  }
};
//字母数字下划线
const word_num_check = (rule, value, callback) => {
  const wordNum = /^[a-z0-9_]{1,}$/;
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (wordNum.test(value)) {
      //验证通过
      if (value.length > rule.max_len || value.length < rule.min_len) {
        callback(new Error(`请输入${rule.min_len}-${rule.max_len}的字母数字`));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error(`请输入${rule.min_len}-${rule.max_len}位的字母数字`));
    }
  }
};
/**
 * 自定义校验
 */
const self_check = (rule, value, callback) => {
  if (rule.con.length == 0) {
    callback(new Error(`请${rule.label}`));
  } else {
    callback();
  }
};
/*
 *验证添加地址配置
 */
const address_Url = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (addressUrl.test(value)) {
      //验证通过
      callback();
    } else {
      //正则表达验证未通过
      callback(new Error(`请输入合法的${rule.label}`));
    }
  }
};
/*
 *验证服务名称
 */
const serve_name = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (serveName.test(value)) {
      //验证通过
      if (value.length > rule.max_len || value.length < rule.min_len) {
        callback(
          new Error(
            `${rule.label}的长度应在${rule.min_len}-${rule.max_len}个字符之间`
          )
        );
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(
        new Error(`${rule.label}仅允许输入汉字、英文字母、数字与特殊字符`)
      );
    }
    z;
  }
};
/**
 * 验证不可输入特殊字符以及符合规定长度
 */
const spec_len = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (specialStr.test(value)) {
      //验证通过
      if (value.length > rule.max_len || value.length < rule.min_len) {
        callback(
          new Error(
            `${rule.label}的长度应在${rule.min_len}-${rule.max_len}个字符之间`
          )
        );
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error(`${rule.label}不能包含标点等特殊字符`));
    }
  }
};
/**
 * 验证密码
 */
const pwd_len = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (value.length > rule.max_len || value.length < rule.min_len) {
      callback(
        new Error(
          `${rule.label}的长度应在${rule.min_len}-${rule.max_len}个字符之间`
        )
      );
    } else {
      console.log();
      if (pwd.test(value)) {
        //验证通过
        callback();
      } else {
        //正则表达验证未通过
        callback(
          new Error(
            `${rule.label}由字母、数字和标点符号(除空格)三者中至少 2 者组成。`
          )
        );
      }
    }
  }
};
/**
 * 验证确认密码
 */
const repwd_len = (rule, value, callback) => {
  console.log(rule, "rule---");
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (pwd.test(value)) {
      //验证通过
      if (value.length > rule.max_len || value.length < rule.min_len) {
        callback(
          new Error(
            `${rule.label}的长度应在${rule.min_len}-${rule.max_len}个字符之间`
          )
        );
      } else {
        if (rule.pass == value) {
          callback();
        } else {
          callback(new Error(`两次输入密码不一致`));
        }
      }
    } else {
      //正则表达验证未通过
      callback(
        new Error(
          `${rule.label}由字母、数字和标点符号(除空格)三者中至少 2 者组成。`
        )
      );
    }
  }
};
/**
 * 验证邮箱
 */
const email_rul = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (email.test(value)) {
      //验证通过
      callback();
    } else {
      //正则表达验证未通过
      callback(new Error(`${rule.label}账号格式错误`));
    }
  }
};
/**
 * 机构代码验证
 */
const code_rul = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (/^[A-z0-9]{1,}$/.test(value)) {
      //验证通过
      if (value.length > rule.len) {
        callback(new Error(`${rule.label}的长度不可大于18位`));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error(`${rule.label}由阿拉伯数字或大写英文字母组成`));
    }
  }
};
/**
 * 验证身份证
 */
const idCard_rul = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (idCard.test(value)) {
      //验证通过
      if (value.length > rule.len) {
        callback(new Error("身份证号的长度不可大于18位"));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error("请输入合法的身份证号"));
    }
  }
};
/**
 * 验证手机号
 */
const phone_rul = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error("请输入手机号"));
  } else {
    if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
      //验证通过
      if (value.length > rule.len) {
        callback(new Error("手机号的长度不可大于11位"));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error("请输入合法的手机号"));
    }
  }
};
const phone_rul1 = (rule, value, callback) => {
  if (!value || value == "") {
    callback();
  } else {
    if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
      //验证通过
      if (value.length > rule.len) {
        callback(new Error("手机号的长度不可大于11位"));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error("请输入合法的手机号"));
    }
  }
};
// 经营日期
const manage_rul = (rule, value, callback) => {
  if (value.length == 0 && rule.status == false) {
    callback(new Error("请选择经营期限"));
  } else {
    callback();
  }
};
// 验证码
const verify_rul = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error("请输入验证码"));
  } else {
    if (/^[0-9]{1,}$/.test(value)) {
      //验证通过
      callback();
    } else {
      //正则表达验证未通过
      callback(new Error("请输入合法的验证码"));
    }
  }
};
// 时间类型
const time_rul = (rule, value, callback) => {
  if (rule.timeType == true) {
    callback();
  } else {
    if (value[0].length == 0) {
      callback(new Error("请选择时间"));
    } else {
      callback();
    }
  }
};
const validateRequired_len = (rule, value, callback) => {
  console.log(rule, "rule---");
  if (value || value == 0) {
    if (reject.test(value)) {
      //验证通过
      if (value.length > rule.max_len) {
        callback(new Error(`${rule.label}的长度不能大于${rule.len}`));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error(`${rule.label}的内容中不能包含特殊字符`));
    }
  } else {
    callback(new Error(`请输入${rule.label}`));
  }
};
const validateName_len = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (regName.test(value)) {
      //验证通过
      if (value.length > rule.max_len) {
        callback(new Error(`${rule.label}的长度不能大于${rule.max_len}`));
      } else {
        callback();
      }
    } else {
      //正则表达验证未通过
      callback(new Error(`${rule.label}的内容中不能包含特殊字符`));
    }
  }
};
const validate_len = (rule, value, callback) => {
  console.log(rule, "rule--");
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (value.length > rule.max_len) {
      callback(new Error(`${rule.label}的长度不能大于${rule.max_len}`));
    } else {
      callback();
    }
  }
};
const revalidate_len = (rule, value, callback) => {
  if (!value || value == "") {
    callback(new Error(`请输入${rule.label}`));
  } else {
    if (value.length > rule.max_len) {
      callback(new Error(`${rule.label}的长度不能大于${rule.max_len}`));
    } else {
      if (rule.pass == value) {
        callback();
      } else {
        callback(new Error(`两次输入密码不一致`));
      }
    }
  }
};
const captcha_err = (rule, value, callback) => {
  callback(new Error(`请输入${rule.label}`));
};
const quotaValid = (rule, value, callback) => {
  let reg = /^[0-9]{1,}$/;
  console.log(value,"value--")
  if (reg.test(value)) {
    if (value >= 0 && value <= 99999) {
      callback();
    } else {
      callback(new Error(`${rule.label}在0-99999之间`));
    }
  } else {
    callback(new Error(`请输入数字`));
  }
}
export default {
  validateRequired_len,
  validateName_len,
  validate_len,
  validate_len1,
  revalidate_len,
  spec_len,
  pwd_len,
  repwd_len,
  email_rul,
  code_rul,
  idCard_rul,
  phone_rul,
  manage_rul,
  verify_rul,
  time_rul,
  captcha_err,
  serve_name,
  address_Url,
  self_check,
  phone_rul1,
  word_num_check,
  account_valid,
  quotaValid
};
